import { Block, BottomSheet, Button, SvgIcon, Typography, palette, spacing } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";

type Props = {
  setIsVisible: (v: boolean) => void;
  handleDeleteService: () => void;
  isVisible: boolean;
  serviceName?: string;
  loading: boolean;
};

const ConfirmDeleteServiceModal = ({
  setIsVisible,
  isVisible,
  serviceName,
  loading,
  handleDeleteService,
}: Props) => {
  const { t } = useTranslation();

  return (
    <BottomSheet
      contentStyle={styles.deleteContainer}
      toggle={() => setIsVisible(false)}
      visible={isVisible}
    >
      <Block alignCenter>
        <Block marginBottom={3} paddingVertical={2}>
          <SvgIcon color={palette.secondary.wrongPink} name="alert-filled" size={65} />
        </Block>
        <Typography variant="newH3">
          {t("screens.serviceDetails.deleteService", { service: serviceName })}
        </Typography>
        <Block marginBottom={3} marginTop={1.5}>
          <Typography center type="secondary" variant="lightLabel">
            {t("screens.serviceDetails.confirmDeleteService")}
          </Typography>
        </Block>
      </Block>
      <Button
        label={t("common.delete")}
        loading={loading}
        onPress={() => handleDeleteService()}
        type="primary"
      />
      <Button label={t("common.goBack")} onPress={() => setIsVisible(false)} type="transparent" />
    </BottomSheet>
  );
};

export default ConfirmDeleteServiceModal;

const styles = StyleSheet.create({
  deleteContainer: {
    padding: spacing.unit * 2.5,
  },
});
